<template>
  <ApplyDecision
    v-bind="props"
    component-type="ApplyPendingFullDecision"
    decision="pending_full"
    :component="component"
  />
</template>

<script setup lang="ts">
  import { ApplyDecisionProps } from "@/models/apply/apply-models"
  import ApplyDecision from "@/components/apply/ApplyDecision.vue"
  import { useLocalizedComponents } from "@versatile-credit-apply/components"

  const props = defineProps<ApplyDecisionProps>()

  const component = useLocalizedComponents(() => props.response, {
    aff_standard: () =>
      import("@/providers/aff_standard/components/AffPendingDecision.vue"),
    bread_standard: () =>
      import("@/providers/bread_standard/components/BreadPendingDecision.vue"),
    genesis_standard: () =>
      import(
        "@/providers/genesis_standard/components/GenesisPendingDecision.vue"
      ),
    snap_standard: () =>
      import("@/providers/snap_standard/components/SnapPendingDecision.vue"),
    synchrony_standard: () =>
      import(
        "@/providers/synchrony_standard/components/SynchronyPendingDecision.vue"
      ),
  })
</script>
